import { render, staticRenderFns } from "./PatientEvent.vue?vue&type=template&id=157a39ec&scoped=true&"
import script from "./PatientEvent.vue?vue&type=script&lang=js&"
export * from "./PatientEvent.vue?vue&type=script&lang=js&"
import style0 from "./PatientEvent.vue?vue&type=style&index=0&id=157a39ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157a39ec",
  null
  
)

export default component.exports